// EmailJS Configuration
export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_19xzx1b', 
  TEMPLATE_ID: 'template_pm3o5g8', 
  PUBLIC_KEY: '_2OodekqduTu90-sg', 
}

export interface EmailTemplateParams extends Record<string, unknown> {
  from_name: string
  from_email: string
  company?: string
  message: string
  to_email: string // Your email address
  sent_date: string
  sent_time: string
} 